import httpService from "./http.service";

class TagsService {
  editTag = (tagId, model) => {
    return httpService.patch(`/tags/${tagId}`, model);
  };
}

const tagsService = new TagsService();
export default tagsService;
